export default 'https://tme.understood.org/assets/clown.eae91b86.lottie'